<script>
  import { onMount } from 'svelte'
  import { fade } from 'svelte/transition'
  import ViewContainer from '../../components/ViewContainer.svelte'
  import PageHeader from '../../components/PageHeader.svelte'
  import Spinner from '../../components/Spinner.svelte'
  import Button from '../../components/Button.svelte'
  import Icon from '../../components/Icon.svelte'
  import { location, push } from 'svelte-spa-router'
  import { isUserAdmin, showInfo, multiFilter } from './../../helpers/utils.js'
  import { modalStore, clientStore, userStore } from '../../state/store'
  import { t } from '../../i18n/i18n'
  import Modal from '../../components/Modal.svelte'
  import ClientAdd from './Client.add.svelte'
  import { getClientData } from '../../state/actions'

  const showAddClient = () => modalStore.toggle('add_client')

  let promise

  onMount(() => {
    promise = getClientData()
  })

  let searchTerm = ''
  $: clients = multiFilter($clientStore, ['name', 'contact_name'], searchTerm)

</script>

  <ViewContainer>
    <PageHeader>
      <h1>{$t.clients}</h1>
      <Button on:click={showAddClient}>{$t.add_client}</Button>
    </PageHeader>

    {#await promise}
      <Spinner />
    {:then}
      <section class="g-search">
        <span class="icon"><Icon name='search' /></span>
        <input type="text" id="search" bind:value={searchTerm} placeholder={$t.search}>
      </section>
      <article class="g-card-list-wrapper">
          {#if $clientStore.length === 0}
            <div>
              <h2>{$t.no_clients}</h2>
              <p>{$t.add_client_text}</p>
            </div>
          {:else}
            {#each clients as data, index}
              <ul on:click={() => push(`${$location}${data._id}`)} class='g-card-list' in:fade|global="{{duration: 250}}">
                {#each Object.entries(data) as [key, val]}
                  {#if 
                    key !== '_id' &&
                    key !== '__v' &&
                    key !== 'tenant' &&
                    key !== 'locations' &&
                    showInfo({key, isAdmin: isUserAdmin($userStore)})
                  }
                    <li>
                      <p>{$t[key]}</p>
                      <p>{val}</p>
                    </li>
                  {/if}
                {/each}
              </ul>
            {/each}
          {/if}
      </article>
    {/await}


  <Modal name='add_client'>
    <h1 slot='header'>{$t.add_new_client}</h1>
    <ClientAdd />
  </Modal>
</ViewContainer>
